import {Component, OnInit, Input, ChangeDetectionStrategy, HostBinding} from '@angular/core';

import * as State from '@shared/state';
import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-wizzard-quantity',
    templateUrl: './wizzard-quantity.shared.component.html',
    styleUrls: ['./wizzard-quantity.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WizzardQuantityComponent implements OnInit {
    private _isMenuFlow: boolean = true;
    public quantity$: Observable<number>;

    @Input() public mobile: boolean = true; /* Set visibility on mobile */
    @Input() public desktop: boolean = false; /* Set visibility on desktop */

    @Input() public type: State.MODAL_TYPE;
    @Input() public size: OLO.Components.BUTTON_SIZE = 'xlg';
    @Input() public mode: OLO.Components.Quantity.QUANTITY_MODE = 'normal';

    @Input() public max: number = 9999;
    @Input() public remove: boolean = false;
    @Input() public minimumHide: boolean = true;
    @Input() public disabled: boolean = false;
    @HostBinding('class') class;

    constructor(
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        if (this.type === 'product') {
            this._isMenuFlow = false;
        }

        if (this._isMenuFlow) {
            this.quantity$ = this.controllers.wizzard.wizzardMenuFlowQuantity$();
        } else {
            this.quantity$ = this.controllers.wizzard.wizzardSimpleItemQuantity$();
            this.class = 'padding-none';
        }
    }

    public handleIncrement($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        if (this._isMenuFlow) {
            return this.controllers.wizzard.wizzardMenuFlowIncrement();
        }

        this.controllers.wizzard.wizzardSimpleItemIncrement();
    }

    public handleDecrement($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        if (this._isMenuFlow) {
            return this.controllers.wizzard.wizzardMenuFlowDecrement();
        }

        this.controllers.wizzard.wizzardSimpleItemDecrement();
    }

    public handleRemove($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        if (this._isMenuFlow) {
            return this.controllers.wizzard.wizzardMenuFlowDecrement();
        }

        this.controllers.wizzard.wizzardSimpleItemDecrement();
    }
}
